import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { NgLocalStorage } from 'core/utils/ng-storage.service';
import { MsalService } from 'msal';
import { AuthenticationService } from 'core/authentication.service';

@Directive({
  selector: '[appDisabledWorkflowRevievPublishElement]'
})
export class DisabledWorkflowRevievPublishElementDirective implements OnInit {
  @Input() appDisabledWorkflowRevievPublishElement;
  @Input() entity;
  constructor(private eleRef: ElementRef, private ngLocalStorage: NgLocalStorage, private msalService: MsalService, private _auth: AuthenticationService) { }
  disableClass = function () {
    this.disabled = true;
    this.eleRef.nativeElement.style.pointerEvents = 'none';
    this.eleRef.nativeElement.style.cursor = 'not-allowed !important';
    this.eleRef.nativeElement.style.opacity = '0.45';
  }
  enableClass = function () {
    this.disabled = true;
    this.eleRef.nativeElement.style.pointerEvents = 'auto';
    this.eleRef.nativeElement.style.cursor = 'pointer';
  }
  ngOnInit() {
    let response = JSON.parse(this.ngLocalStorage.getItem('workflowUserRoles'));
    console.log('workflowUserRoles', response);
    let view = true;
    let edit = false;
    let parentInList = false;
    let roles = this._auth.getUserRoles(this.msalService);
    let enabled = false;
    let inValidRole = false;
    console.log('appDisabledWorkflowRevievPublishElement', this.appDisabledWorkflowRevievPublishElement);
    let entityGroupList = JSON.parse(this.appDisabledWorkflowRevievPublishElement);
    console.log('entityGroupList', entityGroupList);
    roles.forEach((value, key) => {
      let inValidRoleFlag = false;
      let userRolePermissions = response.filter((res) => { return res.RoleName === value });
      if (userRolePermissions.length != 0) {
        entityGroupList.forEach((value, key) => {
          if (value.EntityGroup === undefined)
            value.EntityGroup = "Pages";
          if (userRolePermissions[0][value.EntityGroup] && userRolePermissions[0][value.EntityGroup][this.entity])
            value["editable"] = true;
        });
      }
    });
    entityGroupList.forEach((value, key) => {
      if (!value["editable"] || value["editable"] === undefined)
        inValidRole = true;
    });
    inValidRole ? this.disableClass() : this.enableClass();
  }
}
